module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"carbonMissingMappingDialog.title":"Emissions and Energy Limitations","carbonMissingMappingDialog.subtitle":"There are limitations to the availability and accuracy of the data in our Emissions and Energy reporting. The following product meters are not mapped to emissions, and as a result real CO2e figures might be lower than reality."}}')
  delete Component.options._Ctor
}
